import 'echarts';
import VueECharts from 'vue-echarts';

export const configureVueECharts = (Vue) => {
  Vue.component('VEchart', VueECharts);
};
